export const fetchLocale = (language) => {
  const availableLocales = {
    English: "en",
    Cymraeg: "cy",
    French: "fr",
    German: "de",
    Hungarian: "hu",
    Italian: "it",
    Portuguese: "pt",
    Spanish: "es",
  };
  return availableLocales[language];
};
